import { Palmtree } from "lucide-react";

import { usePessoaEmFerias } from "@/hooks/pessoa/use-pessoa-em-ferias";

import { PersonPresenceList } from "./PersonPresenceList";

export function PessoasEmFeriasList() {
  const { pessoas, loading } = usePessoaEmFerias();

  return (
    <PersonPresenceList
      icon={Palmtree}
      iconClassName="bg-amber-500/10 text-amber-600 dark:text-amber-400"
      title="Em férias agora"
      pessoas={pessoas}
      loading={loading}
      emptyMessage="Ninguém do time ativo está fora no momento."
      ausente
      badge={{
        when: "vazio",
        content: (
          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-emerald-500/15 px-2.5 py-1 font-mono text-[11px] font-medium text-emerald-600 ring-1 ring-inset ring-emerald-500/25 dark:text-emerald-400">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            time completo
          </span>
        ),
      }}
    />
  );
}
